class BlogFilter extends HTMLElement {
  constructor() {
    super();

    const filter = this.querySelector('select');
    const caret = this.querySelector('.icon-caret');

    filter.addEventListener('change', function() {
      window.location.href = filter.value;
    });

    filter.addEventListener('mousedown', function() {
      caret && caret.classList.toggle('icon-caret--open');
    });

    filter.addEventListener('blur', function() {
      caret && caret.classList.remove('icon-caret--open');
    });
  }
}

customElements.define('blog-filter', BlogFilter);
